export default "__VITE_ASSET__DRW0LK8c__"